<!-- LISTA_IMAGEM_G_RESUMO -->
<ion-card (click)="abrirNoticia();">
  <div class="container">
    <div class="data-card" *ngIf="config.mostrar_data == '1'">
      <div class="mes"> {{getMes()}} </div>
      <div class="dia"> {{getDia()}} </div>
    </div>

    <img [src]="config.image | image:'evento'" />
  </div>

  <ion-card-content>
    <ion-grid>
      <ion-row>
        <ion-col size="9">
          <p class="title ellipse two-lines">{{config.title}}</p>

          <p class="subtitle">
            {{config.resume}}
          </p>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="9" style="padding: 0px;">
          <ion-button class="btn-default" expand="block">
            {{config.texto_botao}}

            <ion-icon slot="end" name="arrow-forward-outline"></ion-icon>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-content>
</ion-card>